import { defineMessages, type MessageDescriptor } from 'react-intl';

type MessageKeys =
	| 'attachmentsHeading'
	| 'outputHeading'
	| 'contextHeading'
	| 'rovoSpaceHeading'
	| 'knowledgeHeading'
	| 'conversationHeading'
	| 'emptyContent'
	| 'comingSoon'
	| 'feedbackBannerText';

const messages: Record<MessageKeys, MessageDescriptor> = defineMessages({
	attachmentsHeading: {
		id: 'ai-mate.conversation-assistant.split-layout.default-right-panel.attachments-heading-non-final',
		defaultMessage: 'Attachments',
		description: 'Heading for the list of sources used to generate the chat result.',
	},
	outputHeading: {
		id: 'ai-mate.conversation-assistant.split-layout.default-right-panel.output-heading-non-final',
		defaultMessage: 'Output',
		description: 'Heading for the list of output artefacts produced by the chat result.',
	},
	contextHeading: {
		id: 'ai-mate.conversation-assistant.split-layout.default-right-panel.context-heading-non-final',
		description:
			'Heading for the static Context card shown below the linked Jira work item in the conversation right panel.',
	},
	rovoSpaceHeading: {
		id: 'ai-mate.conversation-assistant.split-layout.default-right-panel.rovo-space-heading-non-final',
		defaultMessage: 'Rovo Space',
		description:
			'Label for the Rovo Space row in the static Context card in the conversation right panel.',
	},
	knowledgeHeading: {
		id: 'ai-mate.conversation-assistant.split-layout.default-right-panel.knowledge-heading-non-final',
		defaultMessage: 'Knowledge',
		description:
			'Label for the Knowledge row in the static Context card in the conversation right panel.',
	},
	emptyContent: {
		id: 'ai-mate.conversation-assistant.split-layout.default-right-panel.empty-content-non-final',
		defaultMessage: 'Empty',
		description:
			'Placeholder content shown in an expanded Rovo Space or Knowledge section of the static Context card.',
	},
	conversationHeading: {
		id: 'ai-mate.conversation-assistant.split-layout.default-right-panel.conversation-heading-non-final',
		defaultMessage: 'Conversation',
		description:
			'Label for the unavailable Conversation row in the static Context card in the conversation right panel.',
	},
	comingSoon: {
		id: 'ai-mate.conversation-assistant.split-layout.default-right-panel.coming-soon-non-final',
		defaultMessage: 'Coming soon',
		description:
			'Lozenge text indicating that the Conversation context feature shown in the static Context card is not available yet.',
	},
	feedbackBannerText: {
		id: 'ai-mate.conversation-assistant.split-layout.default-right-panel.feedback-banner-text-non-final',
		description: 'Text for the feedback banner shown at the top of the session context panel.',
	},
});
export default messages;
